module.exports = __webpack_public_path__ + "static/img/aiHead.2e150944.png";